import { useLogo } from "@/context/LogoContext";
import { Dumbbell } from "lucide-react";
import { useState, useEffect } from "react";

export default function Logo({ className = "w-10 h-10", iconClass = "w-5 h-5", rounded = "rounded-xl" }) {
  const { logoUrl } = useLogo();
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [logoUrl]);
  if (logoUrl && !broken) {
    return <img src={logoUrl} alt="Logo" onError={() => setBroken(true)} className={`${className} ${rounded} object-contain bg-white`} data-testid="company-logo" />;
  }
  return (
    <div className={`${className} ${rounded} bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center`} data-testid="company-logo-fallback">
      <Dumbbell className={`${iconClass} text-emerald-600 dark:text-emerald-400`} />
    </div>
  );
}
